import { propsTypes, SpriteTypes, spriteCategory } from '../types/sprite-types'
import { uuid } from '@/libs/src/utils/tools'
const options = {
    visible: true,
    width: 100,
    height: 100,
    lineWidth: 0, 
    radio: true, 
    imageRatio: true,disableAnchor:true,
}

export default [
    {
        id: uuid(),
        name: "单选框",
        type: SpriteTypes.sprite,
        image: "images/form/radio-checked.png",
        categrory: spriteCategory.from,
        data: {
            name: 'radio',
            x: 100,
            y: 100,
            direction: "vertical",
            checked: '选项二',
            options: [
                { text: "选项一", background: "#ff0000" },
                { text: "选项二", background: "#00ff00" },
                { text: "选项三", background: "#0000ff", isForbidden: true },
            ],
            ...options
        },
    },
    {
        id: uuid(),
        name: "复选框",
        type: SpriteTypes.sprite,
        image: "images/form/checkbox-ok.png",
        categrory: spriteCategory.from,
        data: {
            name: 'checkbox',
            checked: true,
            value: '测试选项一',
            ...options
        },
    },
    {
        id: uuid(),
        name: "开关",
        type: SpriteTypes.sprite,
        image: "images/form/switch.png",
        categrory: spriteCategory.from,
        data: {
            name: 'switch',
            checked: true,
            ...options
        },
    },
    {
        id: uuid(),
        name: "滑动输入",
        type: SpriteTypes.sprite,
        image: "images/form/slider.png",
        categrory: spriteCategory.from,
        data: {
            name: "slider",
            x: 100,
            y: 100,
            width: 300,
            height: 30,
            value: 10,
            textWidth: 50,
            barHeight: 4,
            min: 0,
            max: 100,
            color: "#1890ff",
            background: "#D4D6D9",
            textColor: "#222222",
            unit: "%",
            ...options
        },
    },
    {
        id: uuid(),
        name: "按钮",
        type: SpriteTypes.sprite,
        image: "images/form/anniu.png",
        categrory: spriteCategory.from,
        data: {
            name: "rectangle",
            x: 100,
            y: 100,
            width: 80,
            height: 30,
            borderRadius: 0.2,
            text: "按钮",
            background: "#1890ff",
            color: "#1890ff",
            textColor: "#ffffff",
            activeBackground: "#40a9ff", //选中
            activeColor: "#40a9ff",
            activeTextColor: "#ffffff",
            hoverBackground: "#40a9ff", //鼠标经过
            hoverColor: "#40a9ff",
            hoverTextColor: "#ffffff",
        },
    },
    {
        id: uuid(),
        name: "输入框",
        type: SpriteTypes.sprite,
        image: "images/form/input.png",
        categrory: spriteCategory.from,
        data: {
            x: 100,
            y: 100,
            height: 50,
            width: 200,
            input: true,
            name: "rectangle",
            borderRadius: 0.05,
            ellipsis: true,
            text: "输入数据",
            textAlign: "left",
            color: "#D9D9D9FF",
            textColor: "#000000FF",
            hoverTextColor: "#000000FF",
            activeTextColor: "#000000FF",
            textLeft: 10,
        },
    },
    {
        id: uuid(),
        name: "选择器",
        type: SpriteTypes.sprite,
        image: "images/form/xuanzeqi.png",
        categrory: spriteCategory.from,
        data: {
            x: 100,
            y: 100,
            height: 50,
            width: 200,
            name: "rectangle",
            borderRadius: 0.05,
            ellipsis: true,
            text: "选项1",
            textAlign: "left",
            color: "#D9D9D9FF",
            textColor: "#000000FF",
            hoverTextColor: "#000000FF",
            activeTextColor: "#000000FF",
            textLeft: 10,
            // dropdownList: ["选项1", "选项2", "选项3"],
            dropdownList: [
                { text: "选项1", background: "#ff0000" },
                { text: "选项2", background: "#00ff00" },
                { text: "选项3", background: "#0000ff" },
            ],
        }
    },
]